import React from 'react'
import { Switch } from 'react-router-dom'

import Page from 'components/Page'
import PageHeader from 'components/PageHeader'
import PoolCards from './components/PoolCards'

import dice from 'assets/img/dice.png'

const Pools = () => {
  return (
    <Switch>
      <Page>
        <div>
          <PageHeader
            icon={<img src={dice} height="120" alt="dice" />}
            subtitle="A decentralized token launch service"
            title="You Bet! Launch"
          />
          <PoolCards />
        </div>
      </Page>
    </Switch>
  )
}

export default Pools
